import { render, staticRenderFns } from "./order-statistics-panel.vue?vue&type=template&id=587541f4&scoped=true&"
import script from "./order-statistics-panel.vue?vue&type=script&lang=js&"
export * from "./order-statistics-panel.vue?vue&type=script&lang=js&"
import style0 from "./order-statistics-panel.vue?vue&type=style&index=0&id=587541f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587541f4",
  null
  
)

export default component.exports